<template>
    <div>
      <q-dialog v-model="visible" maximized @input="(val) => $emit('input', val)">
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>{{ title }}</q-toolbar-title>
              <q-btn v-close-popup flat round dense icon="close" />
            </q-toolbar>
          </q-header>
          <q-page-container :class="{'image-container': isTicketImage}" >
            <q-img
                :class="{'image-width': isTicketImage}"
                v-if="visible"
                class="preview-image"
                ref="imageRef"
                :src="virtualSrc"
                :ratio="ratio"
            />
          </q-page-container>
        </q-layout>
      </q-dialog>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ImagePreview',
  props: {
    blobImage: String,
    visible: Boolean,
    title: String
  }
})

class ImagePreview extends Vue {
  get virtualSrc () {
    return window.URL.createObjectURL(this.blobImage.data, {
      type: this.blobImage.data.type
    })
  }

  get isTicketImage () {
    return this.title === 'Imagem do Ticket'
  }

  get ratio () {
    return this.isTicketImage ? 350 / 500 : 1920 / 1080
  }
}
export default ImagePreview
</script>
  <style scoped>
  .image-container {
    display: flex;
    justify-content: center;
  }
  .image-width {
    width: 800px;
  }
  </style>
